import React, { FC } from 'react';
import { TableRow } from '@material-ui/core';
import TableCell from 'src/components/TableCell';
import { Skeleton } from '@material-ui/lab';

const EmployeeRow: FC = () => {
  return (
    <TableRow>
      <TableCell>
        <Skeleton />
      </TableCell>
      <TableCell>
        <Skeleton />
      </TableCell>
      <TableCell>
        <Skeleton />
      </TableCell>
      <TableCell>
        <Skeleton />
      </TableCell>
      <TableCell>
        <Skeleton />
      </TableCell>
      <TableCell>
        <Skeleton />
      </TableCell>
      <TableCell>
        <Skeleton />
      </TableCell>
      <TableCell>
        <Skeleton />
      </TableCell>
      <TableCell>
        <Skeleton />
      </TableCell>
      <TableCell />
    </TableRow>
  );
};

export default EmployeeRow;
